import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import AuthService from '../AuthService';

import Grid from 'material-ui/Grid';

const styles = theme => ({
  root: {
    width: '100%',
    fontFamily: theme.typography.fontFamily
  },
  flex: {
    flex: 1,
    lineHeight: '0.8rem',
    fontSize: '1.2rem'
  },
  footerLinks: {
    color: '#455560'
  },
  appFooter: {
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    backgroundColor: '#f5f5f5'
  }
});

function Footer(props) {
  const { classes } = props;
  const Auth = new AuthService();
  const footerDate = new Date().getFullYear();
  const location = window.location.href;

  return (
    <div className={classes.root}>
      {Auth.userAuthenticated() && location.indexOf('keypad') === -1 && (
        <AppBar position="fixed">
          <Toolbar className={classes.appFooter}>
            <Typography
              variant="title"
              color="primary"
              align="left"
              className={classes.flex}
            >
              <Grid container spacing={8} justify="flex-start">
                <Grid item xs={12} sm={5}>
                  <small className={classes.footerLinks}>
                    Copyright &copy; {footerDate} Formstack Sign
                  </small>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <small>
                    <a
                      className={classes.footerLinks}
                      href="https://formstack.com/data-security/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Security
                    </a>{' '}
                    |{' '}
                    <a
                      className={classes.footerLinks}
                      href="https://formstack.com/legal/terms-of-service/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of Service
                    </a>
                  </small>
                </Grid>
              </Grid>
            </Typography>
          </Toolbar>
        </AppBar>
      )}
    </div>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js